// Import dependencies
import React from 'react';
import axios from 'axios';
import cookie from 'js-cookie';
import { tokenize } from '../../../../../helper';
// import { displayUserAuthAuthorized, displayAffiliateNumber, displayDeviceType, navigageToVideoAnalyticsDetail } from '../../uiAdminHelpers';
import { navigageToVideoAnalyticsDetail } from '../../uiAdminHelpers';
import { FaStar } from 'react-icons/fa'
// Import styling
import './VideoAnalyticsPage.css';
import AdminNavbar from '../../../../reusables/adminNavbar';

// Import config
import config from '../../../../../configs/config.json';
const API_URL = config.API_URL;
const ADMIN_API_URL = API_URL + '/admin';
const SETTINGS_URL = ADMIN_API_URL + '/settings';

class VideoAnalyticsPage extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            videos: [],
            stats: {
                total_partial: 0,
                total_full: 0,
            },
            sortKey: 'URIASC'
        }
    }

    componentDidMount() {
        // When the component (screen) mounts, check cooke if user is already logged in

        var token = cookie.get('token');
        var user_type = cookie.get('user-type');

        if (token) {
            if (user_type === 'admin') {
                // Admin authorized, query the back-end for the login history
                this.fetchVideoViews();

            } else {
                // Not authorized, re-direct to admin log in page
                window.location.href = '/admin';
            }
        } else {
            // No token found, re-direct them to admin log in page
            window.location.href = '/admin'
        }
    }

    truncate = (input) => input.length > 30 ? `${input.substring(0, 30)}...` : input;

    fetchVideoViews = () => {
        axios.get(`${SETTINGS_URL}/analytics?sort=${this.state.sortKey}`, tokenize())
            .then(response => {
                var total_partial = 0;
                var total_full = 0;
                response.data.newResult.forEach((video) => {
                    total_partial = total_partial + video.partial_views
                    total_full = total_full + video.full_views
                })
                this.setState({
                    videos: response.data.newResult, stats: {
                        total_full: total_full,
                        total_partial: total_partial - total_full
                    }
                });
            })
            .catch(error => {
                console.log(error);
            })
    }

    handleSortRequest = (type) => {
        console.log('handleSortRequest(): ', type);
        switch (type) {
            case 'uri':
                (this.state.sortKey === 'URIDESC') ? this.setState({ sortKey: 'URIASC' }) : this.setState({ sortKey: 'URIDESC' });
                break;
            case 'id':
                (this.state.sortKey === 'IDDESC') ? this.setState({ sortKey: 'IDASC' }) : this.setState({ sortKey: 'IDDESC' });
                break;
            case 'title':
                (this.state.sortKey === 'TITLEDESC') ? this.setState({ sortKey: 'TITLEASC' }) : this.setState({ sortKey: 'TITLEDESC' });
                break;
            case 'partial_view':
                (this.state.sortKey === 'PARTIALDESC') ? this.setState({ sortKey: 'PARTIALASC' }) : this.setState({ sortKey: 'PARTIALDESC' });
                break;
            case 'full_view':
                (this.state.sortKey === 'FULLDESC') ? this.setState({ sortKey: 'FULLASC' }) : this.setState({ sortKey: 'FULLDESC' });
                break;
            case 'ratings':
                (this.state.sortKey === 'RATINGASC') ? this.setState({ sortKey: 'RATINGDESC' }) : this.setState({ sortKey: 'RATINGASC' });
                break;
            default:
                this.setState({ sortKey: 'URIDESC' });
        }

        setTimeout(() => {
            this.fetchVideoViews();
        }, 100)
    }

    render() {
        return (<div className="container-fluid">
            <AdminNavbar />

            <h1 className='pageTitle'>Video Analytics</h1>
            <p style={{ textAlign: 'center' }}>*Use <strong>CTR</strong> + <strong>F</strong> to search for video by name.</p>

            <div className='loginStatsContainer shadow-sm rounded mb-4'>
                <div>Partial Views: {this.state.stats.total_partial}</div>
                <div>Full Views: {this.state.stats.total_full}</div>
            </div>

            <table className='table table-striped generalTable loginHistoryTable shadow-sm rounded overflow-hidden mb-5'>
                <thead>
                    <tr>
                        <th className="border-0 align-middle" onClick={() => this.handleSortRequest('uri')}>Video URI</th>
                        <th className="border-0 align-middle" onClick={() => this.handleSortRequest('title')}>Title</th>
                        <th className="border-0 align-middle" onClick={() => this.handleSortRequest('partial_view')}>Partial View</th>
                        <th className="border-0 align-middle" onClick={() => this.handleSortRequest('full_view')}>Full View</th>
                        <th className="border-0 align-middle" onClick={() => this.handleSortRequest('ratings')}>Rating</th>
                    </tr>
                </thead>
                <tbody>
                    {
                        
                        this.state.videos.map((video, index) => {

                            return (<tr key={index}>
                                <td className="align-middle" onClick={() => navigageToVideoAnalyticsDetail(video.video_uri)}>{video.video_uri}</td>
                                <td className="align-middle" onClick={() => navigageToVideoAnalyticsDetail(video.video_uri)}>{this.truncate(video.title)}</td>
                                <td className="align-middle" onClick={() => navigageToVideoAnalyticsDetail(video.video_uri)}>{video.partial_views}</td>
                                <td className="align-middle" onClick={() => navigageToVideoAnalyticsDetail(video.video_uri)}>{video.full_views}</td>
                                <td className="align-middle" onClick={() => navigageToVideoAnalyticsDetail(video.video_uri)}>
                                    <span>{(Math.round(video.avg_rating * 10) / 10) ? (Math.round(video.avg_rating * 10) / 10) : '0'} </span><FaStar color="orange" textAnchor="0" style={{ margin: '0 0 4 2' }} />
                                </td>
                            </tr>)
                        })
                    }
                </tbody>
            </table>
        </div>)
    }
}

export default VideoAnalyticsPage;